import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/composables/i18n';
import { isNil } from '@/utils/misc';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressBar',
  props: {
    value: null,
    max: { default: 100 },
    color: { default: '#6a5ffe' }
  },
  setup(__props: any) {

const props = __props as { value: number | null | undefined, max: number, color: string };



const { t } = useI18n();

const roundedSegmentEndPositionCSS = computed<any>(() => {
  const percentage = props.max !== 0 ? (props.value! / props.max) * 100 : 0;
  return { left: `${percentage}%` };
});

return { __sfc: true,props, t, roundedSegmentEndPositionCSS, isNil }
}

})